import React, { type ReactElement } from 'react';
import type { Decorated } from 'types/vendor';
import type { NavItemElements } from '../types';
import NavSection from './nav_section';

export interface NavSectionsProps {
	children: NavItemElements;
	vendor: Decorated;
}

export const NavSections = ({ children, vendor }: NavSectionsProps) => {
	return (
		<>
			{children.reduce<Array<ReactElement>>((acc, child, index) => {
				if (!child) return acc;

				const renderedChild = React.cloneElement(child, { vendor });
				const title = child.props.title;
				const childKey = child.key ?? title ?? `nav-child-${index}`;

				if (!title) {
					acc.push(
						<React.Fragment key={childKey}>{renderedChild}</React.Fragment>,
					);
					return acc;
				}

				acc.push(
					<NavSection
						key={childKey}
						navId={`nav${title}`}
						shouldHide={!!child.props.shouldHide}
						className={child.props.className}
					>
						{renderedChild}
					</NavSection>,
				);

				return acc;
			}, [])}
		</>
	);
};
